import { render, staticRenderFns } from "./CardSpedizione.vue?vue&type=template&id=7a6e752a"
import script from "./CardSpedizione.vue?vue&type=script&lang=ts"
export * from "./CardSpedizione.vue?vue&type=script&lang=ts"
import style0 from "./CardSpedizione.vue?vue&type=style&index=0&id=7a6e752a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6e752a')) {
      api.createRecord('7a6e752a', component.options)
    } else {
      api.reload('7a6e752a', component.options)
    }
    module.hot.accept("./CardSpedizione.vue?vue&type=template&id=7a6e752a", function () {
      api.rerender('7a6e752a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardSpedizione.vue"
export default component.exports